var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasFilters && !_vm.isLoading
    ? _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "my-0 py-0" },
            _vm._l(_vm.groupedChips, function (values, key) {
              return _c(
                "v-menu",
                {
                  key: key,
                  attrs: {
                    absolute: "",
                    "offset-y": "",
                    "close-on-content-click": false,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "v-chip",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "mr-1 mb-1",
                                    attrs: {
                                      color: "primary",
                                      "text-color": "white",
                                      pill: "",
                                    },
                                  },
                                  "v-chip",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.formatKey(key)) +
                                    " (" +
                                    _vm._s(values.length) +
                                    ")\n                    "
                                ),
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "ml-2",
                                    attrs: { right: "" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.clearGroup(key)
                                      },
                                    },
                                  },
                                  [_vm._v("mdi-close")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _vm._v(" "),
                  _c(
                    "v-list",
                    _vm._l(values, function (value) {
                      return _c(
                        "v-list-item",
                        { key: `${key}-${value}` },
                        [
                          _c(
                            "v-list-item-title",
                            [
                              _c(
                                "v-chip",
                                {
                                  staticClass: "white--text mr-2",
                                  attrs: { color: "primary" },
                                },
                                [
                                  _c("span", { staticClass: "fs-16" }, [
                                    _vm._v(
                                      "\n                              " +
                                        _vm._s(_vm.displayName(key, value)) +
                                        "\n                            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { right: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeFilter(key, value)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                mdi-close\n                            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }